<div *ngIf="alerta" class="alerta">
  <span class="fecha" *ngIf="alerta">{{alerta.fecha | timeAgo}}</span>
  <button *ngIf="alerta.db_id != ''" size="small" nbTooltip="{{labelBorrarAlerta}}" nbButton ghost class="button-header-ghost ms-2" (click)="onDeleteAlerta()">
    <nb-icon  [icon]="iconDelete.icon" [pack]="iconDelete.pack"></nb-icon>
  </button>
</div>
<span *ngIf="alerta" class="alerta-titulo" [nbTooltip]="alerta.titulo">{{alerta.titulo}}</span>

